export default (filters, keyword, sort) => {
  return {
    q: filters,
    keyword: keyword,
    s: sort
  }
}
